/* ================================================================
   Sube el botón flotante de WhatsApp (app "gty-whatsapp-chat-button")
   para que no tape el botón / barra de "Agregar al carrito".
   El botón vive en un shadow root abierto, así que le inyectamos un
   <style>. Desktop tiene una cart-bar (~104px); mobile una barra ATC
   más baja. Ajusta los offsets aquí si hace falta.
   ================================================================ */
(function () {
  var STYLE_ID = 'gty-wacb-position-fix';
  var CSS =
    '.gty-wacb-wrapper{ bottom: 120px !important; }' +
    '@media (max-width: 768px){ .gty-wacb-wrapper{ bottom: 100px !important; } }';

  function applyOffset() {
    var host = document.querySelector('gty-whatsapp-chat-button');
    if (!host || !host.shadowRoot) return false;
    if (!host.shadowRoot.getElementById(STYLE_ID)) {
      var st = document.createElement('style');
      st.id = STYLE_ID;
      st.textContent = CSS;
      host.shadowRoot.appendChild(st);
    }
    return true;
  }

  if (applyOffset()) return;

  // La app carga async: reintenta y observa el DOM hasta que aparezca.
  var tries = 0;
  var iv = setInterval(function () {
    if (applyOffset() || ++tries > 60) clearInterval(iv); // ~30s máx
  }, 500);

  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      if (applyOffset()) { mo.disconnect(); clearInterval(iv); }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
